/**
 * Small caption shown under an image upload control telling the user the
 * recommended dimensions for the image.
 */
import { Box, Typography } from '@mui/material';
import type { SxProps, Theme } from '@mui/material';
import { InfoOutlined as InfoOutlinedIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import type { ImageSize } from '../../constants/imageSizes';

interface ImageSizeHintProps {
  size: ImageSize;
  sx?: SxProps<Theme>;
}

const ImageSizeHint = ({ size, sx }: ImageSizeHintProps) => {
  const { t } = useTranslation();
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 1, ...sx }}>
      <InfoOutlinedIcon sx={{ fontSize: 16, color: 'text.secondary' }} />
      <Typography variant="caption" color="text.secondary">
        {t('components.imageSizeHint.recommended', { width: size.width, height: size.height })}
      </Typography>
    </Box>
  );
};

export default ImageSizeHint;
